import React from 'react';
import doctolibImg from '../../images/icon/doctolib.svg'
import './style.css'

const Scrollbar = ({openTerminModal}) => {

    return(
        <div className="col-lg-12">
            <div className="header-menu">
                <ul className="smothscroll">
                    <li className="termin-button" onClick={openTerminModal}>
                        <img src={doctolibImg} alt="Doctolib" style={{ height: 60, width: 90 }}/>
                    </li>
                </ul>
            </div>
        </div>
        
    )
}

export default Scrollbar;
